import ActivityFilterBar from './ActivityFilterBar';
import FilterWrapper from './FilterWrapper';

// Wrap the ActivityCustomFilter with state handlers
const ActivityCustomFilter = FilterWrapper(ActivityFilterBar);

export default ActivityCustomFilter;
